import * as React from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
// import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import ForumIcon from "@mui/icons-material/Forum";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import {
  Box,
  Button,
  Grid,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
// import { useNavigate } from "react-router-dom";
import color from "../../../components/utils/Colors";
// import CreateCourseSteps from "./CreateCourseSteps";
// import QuestionPaperSteps from "../../QuestionPaper/QuestionPaperSteps";
import CreateCourseSteps from "./CreateCourseSteps";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import {
  getDataFromTable,
  deleteDataFromTable,
} from "../../../services/services";
import { useUser } from "../../../services/Context/UserContext";
import { useSnackbar } from "../../../components/utils/SnackBar";

const CreateCourseInfo = () => {
  const navigate = useNavigate();
  // const handelCreatecourse = () => {
  //   navigate("/CreateCourseSteps");
  // };

  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // const [open1, setOpen1] = React.useState(false);

  // const handleOpen1 = () => {
  //   setOpen1(true);
  // };

  // const handleClose1 = () => {
  //   setOpen1(false);
  // };

  const { user } = useUser();
  const showSnackbar = useSnackbar();
  const [draftCourses, setDraftCourses] = useState<any[]>([]);
  const [courseToDelete, setCourseToDelete] = useState<string | null>(null);
  const [openDaialog, setOpenDaialog] = useState(false);

  const handleCloseDaialog = () => {
    setOpenDaialog(false);
    setCourseToDelete(null);
  };

  const handleConfirmDelete = async () => {
    if (courseToDelete) {
      try {
        await deleteDataFromTable("course", courseToDelete);
        showSnackbar("Draft course deleted successfully", "success");
        fetchDraftCourses();
      } catch (error) {
        showSnackbar("Failed to delete draft course", "error");
        console.error(error);
      }
    }
    setOpenDaialog(false);
  };
  const fetchDraftCourses = async () => {
    if (user?.id) {
      try {
        const response = await getDataFromTable("course", {
          createdBy: user.id,
          status: "draft",
        });
        if (response?.data?.data) {
          setDraftCourses(response.data.data);
        }
      } catch (error) {
        console.error("Failed to fetch draft courses", error);
      }
    }
  };

  useEffect(() => {
    fetchDraftCourses();
  }, [user]);

  const handleEditDraft = (courseId: string) => {
    navigate("/course-landingPage", { state: { courseId } });
  };

  const handleDeleteDraftClick = (courseId: string) => {
    setCourseToDelete(courseId);
    setOpenDaialog(true);
  };

  return (
    <Box
      sx={{
        padding: "30px",
        width: "100%",
        overflow: "hidden",
      }}
    >
      <Box>
        <Box sx={{ mt: 2 }}>
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Card
                sx={{
                  border: "2px solid #2E0A57",
                  borderRadius: "9px 90px 8px 90px",
                  padding: "16px",
                  height: "100%",
                  justifyContent: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Typography
                  variant="h5"
                  component="h2"
                  sx={{
                    textAlign: "center",
                    color: color.textColor,
                    fontWeight: "700",
                  }}
                >
                  Create Course
                </Typography>
                <CardContent
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    alignItems: "center",
                    paddingBottom: 0,
                  }}
                >
                  <CardMedia
                    component="img"
                    alt="video tutorial"
                    image="/assets/Video Folder.png"
                    sx={{
                      height: { xs: "160px" },
                      width: { xs: "60%", md: "30%" },
                      objectFit: "contain",
                      mb: { xs: "20px", md: "0" },
                    }}
                  />
                  <Typography
                    paragraph
                    sx={{
                      textAlign: "center",
                      ml: { md: "16px" },
                      mt: { xs: "16px", md: "0" },
                      flex: 1,
                      color: color.textColor,
                    }}
                  >
                    Upload your lecture with high quality video, pdf or text
                  </Typography>
                </CardContent>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    width: "100%",
                  }}
                >
                  <Button
                    id="button"
                    onClick={handleOpen}
                    variant="text"
                    sx={{
                      color: color.textColor,
                      fontWeight: "700",
                      mt: "0px",
                      textTransform: "none",
                    }}
                  >
                    Get Started
                  </Button>
                  <CreateCourseSteps open={open} handleClose={handleClose} />
                </div>
              </Card>
            </Grid>
            <Grid item xs={12} md={6}>
              <Card
                sx={{
                  border: "2px solid #2E0A57",
                  borderRadius: "9px 90px 8px 90px",
                  padding: "16px",
                  height: "100%",
                  justifyContent: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Typography
                  variant="h5"
                  component="h2"
                  sx={{
                    textAlign: "center",
                    color: color.textColor,
                    fontWeight: "700",
                  }}
                >
                  Create Question Paper
                </Typography>
                <CardContent
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    alignItems: "center",
                    paddingBottom: 0,
                  }}
                >
                  <CardMedia
                    component="img"
                    alt="video tutorial"
                    image="/assets/Pen Folder.png"
                    sx={{
                      height: { xs: "160px" },
                      width: { xs: "60%", md: "30%" },
                      objectFit: "contain",
                      mb: { xs: "20px", md: "0" },
                    }}
                  />
                  <Typography
                    paragraph
                    sx={{
                      textAlign: "center",
                      ml: { md: "16px" },
                      mt: { xs: "16px", md: "0" },
                      flex: 1,
                      color: color.textColor,
                    }}
                  >
                    Help students to know their knowledge by providing question
                    papers.
                  </Typography>
                </CardContent>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    width: "100%",
                  }}
                >
                  <Button
                    id="button"
                    onClick={() => {
                      navigate("/question-form");
                    }}
                    sx={{
                      color: color.textColor,
                      fontWeight: "700",
                      mt: "0px",
                      textTransform: "none",
                    }}
                  >
                    Get Started
                  </Button>
                  {/* <QuestionPaperSteps open={open1} handleClose={handleClose1} /> */}
                </div>
              </Card>
            </Grid>
          </Grid>
        </Box>

        {/* <Box
          component="section"
          sx={{
            // marginTop: "110px",
            height: { xs: "auto", md: "10px" },
            border: "2px solid",
            borderColor: color.firstColor,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: { xs: "20px", md: "80px" },
            background: "#E5DDF0",
            borderRadius: "16px",
            boxShadow: 0,
            opacity: "0.8",
            flexDirection: { xs: "column", md: "row" },
            textAlign: "center",
          }}
        >
          <Button
            // variant="outlined"
            sx={{
              height: { xs: "auto", md: "50px" },
              px: { xs: "20px", md: "40px" },
              border: "2px solid",
              borderRadius: "12px",
              borderColor: color.firstColor,
              color: color.firstColor,
              fontWeight: "700",
              mb: { xs: "20px", md: "0" },
            }}
            onClick={handleOpen}
          >
            Create Course
          </Button>
          <CreateCourseSteps open={open} handleClose={handleClose} />
          <Typography
            variant="h5"
            sx={{ color: color.textColor, fontWeight: "600" }}
          >
            Create your course from here
          </Typography>
        </Box> */}
        <Box sx={{ mt: 8 }}>
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Card
                sx={{
                  border: "2px solid #2E0A57",
                  borderRadius: "9px 90px 8px 90px",
                  padding: "16px",
                  height: "100%",
                  justifyContent: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Typography
                  variant="h5"
                  component="h2"
                  sx={{
                    textAlign: "center",
                    color: color.textColor,
                    fontWeight: "700",
                  }}
                >
                  Get Started with Video
                </Typography>
                <CardContent
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    alignItems: "center",
                    paddingBottom: 0,
                  }}
                >
                  <CardMedia
                    component="img"
                    alt="video tutorial"
                    image="/assets/3809105 1.png"
                    sx={{
                      height: { xs: "160px" },
                      width: { xs: "60%", md: "30%" },
                      objectFit: "contain",
                      mb: { xs: "20px", md: "0" },
                    }}
                  />
                  <Typography
                    paragraph
                    sx={{
                      textAlign: "center",
                      ml: { md: "16px" },
                      mt: { xs: "16px", md: "0" },
                      flex: 1,
                      color: color.textColor,
                    }}
                  >
                    If you have any doubt how to create a video, click here for
                    guidance.
                  </Typography>
                </CardContent>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    width: "100%",
                  }}
                >
                  <Button
                    id="button"
                    variant="text"
                    sx={{
                      color: color.textColor,
                      fontWeight: "700",
                      mt: "0px",
                      textTransform: "none",
                    }}
                  >
                    Get Started
                  </Button>
                </div>
              </Card>
            </Grid>
            <Grid item xs={12} md={6}>
              <Card
                sx={{
                  border: "2px solid #2E0A57",
                  borderRadius: "9px 90px 8px 90px",
                  padding: "16px",
                  height: "100%",
                  justifyContent: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Typography
                  variant="h5"
                  component="h2"
                  sx={{
                    textAlign: "center",
                    color: color.textColor,
                    fontWeight: "700",
                  }}
                >
                  Build your audience
                </Typography>
                <CardContent
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    alignItems: "center",
                    paddingBottom: 0,
                  }}
                >
                  <CardMedia
                    component="img"
                    alt="video tutorial"
                    image="/assets/OKLG6X0 1.png"
                    sx={{
                      height: { xs: "160px" },
                      width: { xs: "60%", md: "30%" },
                      objectFit: "contain",
                      mb: { xs: "20px", md: "0" },
                    }}
                  />
                  <Typography
                    paragraph
                    sx={{
                      textAlign: "center",
                      ml: { md: "16px" },
                      mt: { xs: "16px", md: "0" },
                      flex: 1,
                      color: color.textColor,
                    }}
                  >
                    Set your course for success in building your students
                  </Typography>
                </CardContent>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    width: "100%",
                  }}
                >
                  <Button
                    id="button"
                    variant="text"
                    sx={{
                      color: color.textColor,
                      fontWeight: "700",
                      mt: "0px",
                      textTransform: "none",
                    }}
                  >
                    Get Started
                  </Button>
                </div>
              </Card>
            </Grid>
          </Grid>
        </Box>

        <Box>
          <Card
            sx={{
              mt: 8,
              border: "2px solid #2E0A57",
              borderRadius: "9px 90px 8px 90px",
              padding: "16px 26px",
              height: "100%",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography
              variant="h5"
              component="h2"
              sx={{
                textAlign: "center",
                color: color.textColor,
                fontWeight: "700",
              }}
            >
              Join as a new teacher
            </Typography>
            <CardContent
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                alignItems: "center",
                paddingBottom: 0,
              }}
            >
              <CardMedia
                component="img"
                alt="video tutorial"
                image="/assets/20944805 1.png"
                sx={{
                  height: { xs: "160px" },
                  width: { xs: "60%", md: "15%" },
                  objectFit: "contain",
                  mb: { xs: "20px", md: "0" },
                }}
              />
              <Typography
                paragraph
                sx={{
                  textAlign: "center",
                  ml: { md: "16px" },
                  mt: { xs: "16px", md: "0" },
                  flex: 1,
                  color: color.textColor,
                }}
              >
                Get exclusive tips and resources designed to help you launch
                your first course faster!
              </Typography>
            </CardContent>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
              }}
            >
              <Button
                id="button"
                variant="text"
                sx={{
                  color: color.textColor,
                  fontWeight: "700",
                  mt: "0px",
                  textTransform: "none",
                }}
              >
                Get Started
              </Button>
            </div>
          </Card>
        </Box>
      </Box>

      <Box
        component="section"
        sx={{
          marginTop: "70px",
          padding: { xs: "20px", md: "120px" },
          border: "2px solid #2E0A57",
          borderRadius: "180px 9px 180px 9px",
          boxShadow: 0,
          bgcolor: "white",
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          flexDirection: { xs: "column", md: "row" },
          textAlign: "center",
        }}
      >
        <Box sx={{ mb: { xs: "20px", md: "0" } }}>
          <CardMedia
            component="img"
            alt="video tutorial"
            image="/assets/Test Your Video.svg"
            sx={{
              height: { xs: "60px" },
              width: { xs: "60px" },
              objectFit: "contain",
              m: "auto",
              mb: { xs: "10px", md: "10px" },
            }}
          />
          {/* <OndemandVideoIcon sx={{ fontSize: "60px", color: "#2b79c2" }} /> */}
          <Typography variant="h6">Test Your Video</Typography>
        </Box>
        <Box sx={{ mb: { xs: "20px", md: "0" } }}>
          <CardMedia
            component="img"
            alt="video tutorial"
            image="/assets/Teachers Community.svg"
            sx={{
              height: { xs: "60px" },
              width: { xs: "60px" },
              objectFit: "contain",
              m: "auto",
              mb: { xs: "10px", md: "10px" },
            }}
          />
          {/* <ForumIcon sx={{ fontSize: "60px", color: "#f05542" }} /> */}
          <Typography variant="h6">Teachers Community</Typography>
        </Box>
        <Box>
          <CardMedia
            component="img"
            alt="video tutorial"
            image="/assets/Help and Support.svg"
            sx={{
              height: { xs: "60px" },
              width: { xs: "60px" },
              objectFit: "contain",
              m: "auto",
              mb: { xs: "10px", md: "10px" },
            }}
          />
          {/* <SupportAgentIcon sx={{ fontSize: "60px", color: "#ebc15c" }} /> */}
          <Typography variant="h6">Help and Support</Typography>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          height: "250px",
          mt: "70px",
          textAlign: "center",
        }}
      >
        <Typography
          variant="h4"
          sx={{ color: color.textColor, fontWeight: "500", mb: "20px" }}
        >
          Are You Ready To Join With Us?
        </Typography>
        <Button
          // variant="outlined"
          sx={{
            height: "50px",
            px: { xs: "20px", md: "40px" },
            border: "2px solid",
            borderRadius: "12px",
            borderColor: color.firstColor,
            color: color.firstColor,
            fontWeight: "700",
          }}
          onClick={handleOpen}
        >
          Create Course
        </Button>
      </Box>

      <Dialog
        open={openDaialog}
        onClose={handleCloseDaialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Delete Draft Course?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this draft course? This action
            cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDaialog} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="error" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default CreateCourseInfo;
